inherit("Storage", {
	parent: `Class`,
	singleton: true,
	api: {
		/**
		 * @function get
		 * @param {Object} options
		 * @param {string} options.key // e.g. `cart_token`
		 * @returns {string}
		 * @description A wrapper for localStorage.getItem()
		 *
		 * @example <caption>const cart_token = Storage.get({ key: `cart_token` });</caption>
		 */
		get: {
			public: true,
			value(context, options) {
				const { key } = options;

				try {
					const { localStorage } = window;

					if (!this.isObject(localStorage)) {
						this.log({ message: `Local storage is not supported in this browser` });
						return null;
					}

					if (this.isString(key, 1)) {
						return localStorage.getItem(key);
					}
				} catch (reason) {
					this.log({ message: `An error occurred while retrieving the value from local storage, %0`, args: [reason] });

					return null;
				}
			},
		},

		/**
		 * @function set
		 * @param {Object} options
		 * @param {string} options.key
		 * @param {string} options.value
		 * @description A wrapper for localStorage.setItem()
		 *
		 * @example <caption>Storage.set({ key: `cart_token`, value: cart.token });</caption>
		 */
		set: {
			public: true,
			value(context, options) {
				const { key: k, value: v } = options;

				try {
					const { localStorage } = window;

					if (!this.isObject(localStorage)) {
						this.log({ message: `Local storage is not supported in this browser` });
						return;
					}

					if (this.isString(k, 1) && (this.isString(v, 1) || this.isInt(v))) {
						localStorage.setItem(k, v);
					}
				} catch (reason) {
					this.log({ message: `An error occurred while setting the value in local storage, %0`, args: [reason] });

					return;
				}
			},
		},

		/**
		 * @function remove
		 * @param {Object} options
		 * @param {string} options.key // e.g. `cart_token`
		 * @description A wrapper for localStorage.removeItem()
		 *
		 * @example <caption>Storage.remove({ key: `cart_token` });</caption>
		 */
		remove: {
			public: true,
			value(context, options) {
				const { key } = options;

				try {
					const { localStorage } = window;

					if (!this.isObject(localStorage)) {
						this.log({ message: `Local storage is not supported in this browser` });
						return;
					}

					if (this.isString(key, 1)) {
						localStorage.removeItem(key);
					}
				} catch (reason) {
					this.log({ message: `An error occurred while removing the value from local storage, %0`, args: [reason] });

					return;
				}
			},
		},
	},
});

//# sourceMappingURL=Storage.js.map